import React, { useState } from 'react';
import HowItWorks from '../UI/HowItsWorks';

const HowItWorksWalk = () => {
    

    const steps = [
        {
            number: 1,
            title: "Consultation & Project Brief",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2FHOW_IT_WORKS_icon%2FConsultation_and_Project_Brief.png?alt=media&token=f3bc5ff5-f052-4824-b560-e429e9310aa7",
            description: ""
        },
        
        {
            number: 2,
            title: "3D Modeling  & Design",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2FHOW_IT_WORKS_icon%2F3D_Modeling_and_Design.png?alt=media&token=ec5192bf-c9fc-489c-8760-ea6bedc0317c",
            description: ""
        },
        
       
        {
            number: 3,
            title: "Rendering & Animation",
            icon:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2FHOW_IT_WORKS_icon%2FRendering_and_Animation.png?alt=media&token=66ba6f1b-c35a-4892-815c-45d6d871fb1a",
            description: ""
        },
        {
            number: 4,
            title: "Client Reviews & Modification",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2FHOW_IT_WORKS_icon%2FClient_Review_and_Modifications.png?alt=media&token=c34510d8-b005-432c-b553-0a304b85f4e9",
            
            description: ""
        },
         
       
        {
            number: 5,
            title: "Final Delivery",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2FHOW_IT_WORKS_icon%2FClient_Review_and_Modifications.png?alt=media&token=c34510d8-b005-432c-b553-0a304b85f4e9",
            
            description: ""
        },
    ];


    return (
        <><HowItWorks steps={steps}/></>
    );
};

export default HowItWorksWalk;
